import * as R from 'ramda';
import angular from 'angular';

export default function ConfirmControlsReviewDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  confirmDialog,
  loaderService,
  ssDialogService,
  vmDataService,
  selectRiskControlsForReviewDialog,
  performControlsReviewDialog,
  completeControlReviewWithNoControlsDialog,
) {
  const vm = this;

  vm.submitType = '';
  vm.incompleteRiskControls = R.reject(
    R.propEq('isComplete', true),
    vm.currentControlsReviewTask.riskControlReviewTaskControls,
  );
  vm.handleConfirmControlsReviewFormSubmit = _handleConfirmControlsReviewFormSubmit;
  vm.handleCloseDialog = _handleCloseDialog;

  /** **********************************************
   * Event Handlers
   */

  function _handleConfirmControlsReviewFormSubmit($event) {
    _closeDialog().then(() => {
      if (vm.submitType === 'discard') {
        // eslint-disable-next-line max-len
        return _showDiscardControlReviewTaskConfirmDialog($event);
      }
      loaderService.showViewLoader = true;
      return vmDataService.getRiskControlsInfoByProduct(vm.product.productId).then(response => {
        loaderService.showViewLoader = false;
        const currentControlsReviewTask = response.data;

        if (currentControlsReviewTask.riskControls.length > 0) {
          return showPerformControlsReviewDialog($event, {
            vendor: vm.vendor,
            product: vm.product,
            currentControlsReviewTask,
            selectRiskControlsForReviewDialog,
          });
        } else {
          completeControlReviewWithNoControlsDialog.show(
            $event,
            vm.product,
            vm.vendor,
            selectRiskControlsForReviewDialog,
            vm.currentControlsReviewTask.riskControlReviewTaskId,
            $rootScope,
          );
        }
      });
    });
  }

  function _handleConfirmDiscard($event) {
    loaderService.showViewLoader = true;
    return vmDataService.deleteRiskControlReviewTaskByProductId(vm.product.productId).then(() =>
      vmDataService.getControlsForProductReview(vm.product.productId).then(response => {
        vm.currentControlsReviewTask.riskControlReviewTaskId = -1;
        loaderService.showViewLoader = false;
        const controlsForProductReview = response.data.product;

        angular.extend(vm.product, controlsForProductReview);
        _closeDiscardControlReviewTaskDialog().then(() => {
          showSelectRiskControlsForReviewDialog($event);
        });
        alerts.success(
          'The Risk Controls Review Task has successfully been discarded. ' +
            'Select Risk Controls to begin a new Task.',
        );
      }),
    );
  }

  function _handleCancelDelete() {
    _closeDiscardControlReviewTaskDialog();
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  /** **********************************************
   * Private Functions
   */

  function showSelectRiskControlsForReviewDialog($event) {
    ssDialogService.dialogs.vendorManagement.selectRiskControlsForReviewDialog = ssDialogService.alert(
      selectRiskControlsForReviewDialog.getOptions($event, {
        riskControlReviewTaskId: vm.currentControlsReviewTask.riskControlReviewTaskId,
        product: vm.product,
        vendor: vm.vendor,
      }),
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.selectRiskControlsForReviewDialog);
  }

  function _closeDiscardControlReviewTaskDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.discardControlReviewTaskConfirmDialog);
  }

  function _showDiscardControlReviewTaskConfirmDialog($event) {
    ssDialogService.dialogs.vendorManagement.discardControlReviewTaskConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Discard Risk Controls Review Task?',
        message:
          'Are about to discard the Control Reviews that have not marked as complete. ' +
          'Are you sure you want to discard these Control Reviews?',
        handleYesClick: _handleConfirmDiscard,
        handleNoClick: _handleCancelDelete,
      }),
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.discardControlReviewTaskConfirmDialog);
  }

  function showPerformControlsReviewDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.performControlsReviewDialog = ssDialogService.alert(
      performControlsReviewDialog.getOptions($event, locals),
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.performControlsReviewDialog);
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.confirmControlsReviewDialog);
  }
}

ConfirmControlsReviewDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'confirmDialog',
  'loaderService',
  'ssDialogService',
  'vmDataService',
  'selectRiskControlsForReviewDialog',
  'performControlsReviewDialog',
  'completeControlReviewWithNoControlsDialog',
];
